import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ProfileRegpage.scss";
import Woroworo from "../../components/Woroworo/Woroworo";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth, db, updateProfile } from "../../../features/firebase";
import Loading from "../../components/Loading/Loading";
import { Helmet } from "react-helmet-async";
import useAuthStore from "../../../features/store";

const ProfileRegpage = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userState = location.state || {};
  const [ann, setAnn] = useState(false);
  const [loading, setLoading] = useState(false);

  const [namaPanggilan, setNamaPanggilan] = useState("");
  const [emailUtama, setEmailUtama] = useState("");
  const [nomorWhatsapp, setNomorWhatsapp] = useState("");

  const [getInfoPanggilan, setGetInfoPanggilan] = useState(false);
  const [getInfoEmail, setGetInfoEmail] = useState(false);
  const [getInfoNoWa, setGetInfoNoWa] = useState(false);

  const { setUserDB } = useAuthStore();

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue =
  //       "Menyegarkan halaman ini akan mereset data, apakah kamu yakin?";
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  useEffect(() => {
    const checkUser = async () => {
      setLoading(true);
      try {
        if (!user) {
          navigate("/login");
        } else if (userState.unregistered) {
          setAnn(true);
        } else if (!user.emailVerified) {
          navigate("/verifikasi");
        }
        const docRef = doc(db, "registered", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          navigate("/");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    checkUser();
  }, [user, navigate, userState.unregistered]);

  const kefal = () => {
    setAnn(false);
  };

  const handleNamaPanggilanChange = (e) => {
    setNamaPanggilan(e.target.value);
  };

  const handleNomorWhatsappChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setNomorWhatsapp(value);
    }
  };

  const handleEmailUtamaChange = (e) => {
    setEmailUtama(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (user) {
      setLoading(true);
      try {
        await updateProfile(auth.currentUser, {
          displayName: namaPanggilan,
        });
        setDoc(doc(db, "registered", user.uid), {
          namaPanggilan: namaPanggilan,
          emailUtama: emailUtama,
          nomorWhatsapp: nomorWhatsapp,
          registered: true,
          role: "pengguna",
        });
        const userState = { successReg: true };
        navigate("/", { state: userState });
      } catch (error) {
        navigate("/registrasi-profil");
      } finally {
        const docRef = doc(db, "registered", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserDB(docSnap.data());
        }

        setLoading(false);
      }
    }
  };

  const [yakin, setYakin] = useState(false);

  const submittrue = () => {
    if (namaPanggilan && emailUtama && nomorWhatsapp) {
      setYakin(true);
    }
  };

  return (
    <div className="registerpage">
      <Helmet>
        <title>KIRMAGO | Set Profile</title>
      </Helmet>
      {loading && <Loading />}
      <Woroworo
        text={`Lakukan registrasi data untuk akun ${user && user.email}`}
        kefal={kefal}
        popup={ann}
      />
      <div className="registerpage-big-box">
        {/* <pre>{JSON.stringify(user, null, 2)}</pre> */}
        <div className="upper-box">
          <h1>
            Halo, {user.displayName ? user.displayName : "KIRMAGO friends"}
          </h1>
          {user.photoURL && <img src={user.photoURL} alt="source" />}
        </div>
        <p>
          Isi form basic data dibawah ini sebelum melakukan aktivitas di website
          kirmago (bersifat wajib)
        </p>
        <form className="registerpage-box" onSubmit={handleSubmit}>
          <div className="grif">
            <h4>Nama Panggilan {namaPanggilan}</h4>
            <i
              className="fa-solid fa-circle-info"
              onClick={() => setGetInfoPanggilan(!getInfoPanggilan)}
            ></i>
          </div>
          {getInfoPanggilan && (
            <p className="example-idat">
              Fungsi dari nama panggilan ini agar website dan kami dapat
              mengidentifikasi agar mudah memanggil mu! contohnya (ex. faris)
            </p>
          )}
          <input
            value={namaPanggilan}
            onChange={handleNamaPanggilanChange}
            type="text"
            placeholder="nama panggilan"
            maxLength={30}
            required
          />

          <div className="grif">
            <h4>Nomor Whatsapp {nomorWhatsapp}</h4>
            <i
              className="fa-solid fa-circle-info"
              onClick={() => setGetInfoNoWa(!getInfoNoWa)}
            ></i>
          </div>
          {getInfoNoWa && (
            <p className="example-idat">
              Fungsi dari nomer whatsapp ini agar website dan kami dapat
              menghubungi kamu! gunakan kode negara contohnya (ex. 62812xxxxxx)
            </p>
          )}
          <input
            value={nomorWhatsapp}
            onChange={handleNomorWhatsappChange}
            type="text"
            placeholder="nomor whatsapp"
            maxLength={15}
            required
          />

          <div className="grif">
            <h4>Email Utama {emailUtama}</h4>
            <i
              className="fa-solid fa-circle-info"
              onClick={() => setGetInfoEmail(!getInfoEmail)}
            ></i>
          </div>
          {getInfoEmail && (
            <p className="example-idat">
              Fungsi dari email ini agar website dan kami dapat menghubungi
              kamu! pastikan email yang kamu masukkan benar.
            </p>
          )}
          <input
            value={emailUtama}
            onChange={handleEmailUtamaChange}
            type="email"
            placeholder="email utama"
            maxLength={50}
            required
          />
          {yakin ? (
            <div className="utu">
              <p>Apakah datamu sudah betul?</p>

              <div className="keyakinan">
                <button className="subityes" type="submit">
                  ya, saya yakin
                </button>
                <button className="subitno" onClick={() => setYakin(false)}>
                  tidak, belum yakin
                </button>
              </div>
            </div>
          ) : (
            <button className="subit" onClick={submittrue}>
              Submit
            </button>
          )}
        </form>
      </div>
      <img
        className="budegmode"
        src="https://telegra.ph/file/cb2d6f386db25f2bdc772.png"
        alt="source"
      />
    </div>
  );
};

export default ProfileRegpage;
